"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonParser = void 0;
class JsonParser {
    constructor() {
        this.priority = 0;
    }
    use(resource) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const type = (_a = (resource.response && resource.response.headers['content-type'])) !== null && _a !== void 0 ? _a : '';
            if (type.startsWith('application/json') || type.startsWith('text/plain')) {
                resource.json = yield resource.response.json();
            }
        });
    }
}
exports.JsonParser = JsonParser;
